// Formatiert einen juristischen Text (Gefängnisordnung): fette §-Hauptüberschriften,
// eingerückte Unterabsätze je nach Gliederungstiefe (§x.y, §x.y.z ...).
export function LegalText({ text }) {
  const lines = (text || "").split("\n");
  return (
    <div className="space-y-1">
      {lines.map((raw, i) => {
        const line = raw.trim();
        if (!line) return <div key={i} className="h-3" aria-hidden="true" />;

        if (line.startsWith("GEFÄNGNISORDNUNG DES")) {
          return (
            <p key={i} className="font-heading font-black text-lg sm:text-xl text-zinc-100 uppercase tracking-tight pb-1">
              {line}
            </p>
          );
        }
        if (line === "Gefängnisordnung San Andreas") {
          return (
            <p key={i} className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500 pb-4">
              {line}
            </p>
          );
        }

        const m = line.match(/^§\s?(\d+(?:\.\d+)*)\s+([\s\S]*)$/);
        if (m) {
          const num = m[1];
          const rest = m[2];
          const depth = (num.match(/\./g) || []).length;
          if (depth === 0) {
            return (
              <h3 key={i} className="font-heading font-bold text-base sm:text-lg text-primary uppercase tracking-wide pt-6 pb-1">
                §{num} {rest}
              </h3>
            );
          }
          return (
            <p
              key={i}
              style={{ paddingLeft: `${depth * 1.4}rem` }}
              className="text-sm sm:text-base text-zinc-200 leading-relaxed break-words [overflow-wrap:anywhere]"
            >
              <span className="font-bold text-zinc-100">§{num}</span> {rest}
            </p>
          );
        }

        return (
          <p key={i} className="text-sm sm:text-base text-zinc-300 leading-relaxed break-words [overflow-wrap:anywhere]">
            {line}
          </p>
        );
      })}
    </div>
  );
}
